import React, { memo } from 'react';
import { useHistory } from 'react-router-dom';
import RowCenterButton from '../molecules/RowCenterButton';
import DefaultButton from '../molecules/DefaultButton';

interface Props {
  reception_cd: string;
  status_code: number;
  moveNextStep: VoidFunction;
  reception_id: number;
}

// KWANKGM04320_近代化資金借入申込結果確認
const FooterConfirmationOfMainExaminationResults: React.FC<Props> = ({
  reception_cd,
  reception_id,
  status_code,
  moveNextStep,
}) => {
  const history = useHistory();

  const handleClickNext = () => {
    moveNextStep();
    history.push(`/reception/${reception_cd}/${reception_id}/${status_code}/confirm`);
  };

  return (
    <>
      <p className="mt-5">お申込情報を確認後、「契約申込に進む」ボタンを押して続けて下さい。</p>
      <RowCenterButton>
        <DefaultButton label="契約申込に進む" strong={false} handleClick={handleClickNext} />
      </RowCenterButton>
    </>
  );
};

export default memo(FooterConfirmationOfMainExaminationResults);
